import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/* eslint-disable prefer-const */
import BaseFoundation from '../base/foundation';
export default class BreadcrumbFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign({}, adapter));
  }

  handleClick(info, event) {
    this._adapter.notifyClick(info, event);
  }

  handleExpand(clickEvent) {
    this._adapter.expandCollapsed(clickEvent);
  }

  genRoutes(routes) {
    return _mapInstanceProperty(routes).call(routes, route => {
      if (typeof route !== 'object') {
        return {
          name: route,
          _origin: {
            name: route
          }
        };
      }

      let config = {};
      config._origin = route;
      return _Object$assign(_Object$assign({}, config), route);
    });
  }

}